export default "__VITE_ASSET__CoCYlmbc__"